export default __webpack_public_path__ + "b0da5df7c2ae547fe9eb4314693d73b7.png";